export default "__VITE_ASSET__CyIKAaAc__"